import { Helmet } from 'react-helmet-async';

import { findCDNBaseUrlFromUrl } from '@zooplus/commons-lang';

import { getAppConfig } from '@config/get-app-config';
import { getKeycloakUrl, getMktExternalUrl } from '@utilities/utils';

const MetaTag = () => {
  const { site, environment } = getAppConfig();
  const mktExternalUrl = getMktExternalUrl(environment);
  const keycloakUrl = `${getKeycloakUrl(environment)}.${site.domain}`;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <link rel="icon" href="/favicon.ico" />
      <meta id="meta-robots" name="robots" content="noindex, follow" />
      <link rel="preconnect" href={findCDNBaseUrlFromUrl()} />
      <link rel="preconnect" href={mktExternalUrl} />
      <link rel="preconnect" href={keycloakUrl} />
    </Helmet>
  );
};

export default MetaTag;
